import { BotId, IntentId, NlpModelId } from '@feedyou-ai/feedbot-schema'

import { FeedbotThunk } from '../../../../../../../../../store/types'
import { NlpLogGroup, NlpLogDbPartitionDescriptor } from '../../../../../../types'
import { nlpTrainingApi } from '../../../../../../../../../features/nlpTraining/nlpTrainingApi'

export function requestForProcessUtterance(params: {
  botId: BotId
  modelId: NlpModelId
  intentId: IntentId
  logGroup: NlpLogGroup
  partition: NlpLogDbPartitionDescriptor
}): FeedbotThunk<Promise<void>> {
  return async dispatch => {
    const { botId, modelId, intentId, logGroup, partition } = params

    const query = logGroup.query
    const payload = {
      processedModelId: modelId,
      processedIntentId: intentId,
      rowsToProcess: logGroup.dbRowDescriptors
    }

    return dispatch(
      nlpTrainingApi.endpoints.processUtterance.initiate({ botId, query, payload, partition })
    ).unwrap()
  }
}
